"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Calculate the angle between two points..
 */
exports.angleBetweenPoints = function (x1, y1) { return function (x2, y2) { return (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI; }; };
/**
 * Calculate the distance between two points.
 */
exports.distanceBetweenPoints = function (x1, y1) { return function (x2, y2) {
    var xDiff = x2 - x1;
    var yDiff = y2 - y1;
    return Math.sqrt(xDiff * xDiff + yDiff * yDiff);
}; };
/**
 * Compares to objects to see if their values are equal.
 * Only compares a single level.
 *
 * @param a First object
 * @param b Second object
 */
exports.objectsAreEqual = function (a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var _i = 0, aProps_1 = aProps; _i < aProps_1.length; _i++) {
        var prop = aProps_1[_i];
        // If values of same property are not equal,
        // objects are not equivalent
        if (a[prop] !== b[prop]) {
            return false;
        }
    }
    // If we made it this far, objects are considered equivalent
    return true;
};
/**
 * Convert new Offset to a percentage of an (parent) element.
 */
exports.convertOffsetToPercentOrPixels = function (shouldConvertToPercent, parent) { return function (offset) {
    return shouldConvertToPercent
        ? {
            left: exports.round((offset.left / parent.offsetWidth) * 100) + "%",
            top: exports.round((offset.top / parent.offsetHeight) * 100) + "%",
        }
        : {
            left: exports.round(offset.left) + "px",
            top: exports.round(offset.top) + "px",
        };
}; };
/**
 * Round all position properties (left, top, width, height)
 * to an interval of the appropriate snap value.
 */
exports.snapPositionValues = function (snapValues) { return function (input) {
    if (exports.areBothSnapsUndefined(snapValues)) {
        return input;
    }
    return Object.keys(input).reduce(function (carrier, key) {
        var _a;
        var inputValue = input[key];
        var snapValue = exports.assignSnapToKey(key, snapValues);
        var outputValue = typeof snapValue === 'number' && typeof inputValue === 'number'
            ? exports.round(inputValue, snapValue)
            : inputValue;
        return Object.assign({}, carrier, (_a = {},
            _a[key] = outputValue,
            _a));
    }, {});
}; };
/**
 * Assign snapXTo or snapYTo appropriately to a position key.
 */
exports.assignSnapToKey = function (key, snapValues) {
    switch (key) {
        case 'left':
            return snapValues.x;
        case 'width':
            return snapValues.x;
        case 'top':
            return snapValues.y;
        case 'height':
            return snapValues.y;
        default:
            return undefined;
    }
};
/**
 * Check if both snap dimension are not defined.
 */
exports.areBothSnapsUndefined = function (snapValues) {
    return snapValues.x === undefined && snapValues.y === undefined;
};
exports.getSnapValues = function (snapTo, snapXTo, snapYTo) { return ({
    x: snapXTo === undefined ? snapTo : snapXTo,
    y: snapYTo === undefined ? snapTo : snapYTo,
}); };
var RESIZE_HANDLE_LOCATIONS = [
    'n',
    'ne',
    'e',
    'se',
    's',
    'sw',
    'w',
    'nw',
];
/**
 * Generates configuration values useful for building resize observables.
 * Configs are built for each side and corner (8 configs in total).
 */
exports.calculateResizeObservableConfigs = function (handleLocations) {
    if (handleLocations === void 0) { handleLocations = RESIZE_HANDLE_LOCATIONS; }
    return handleLocations.map(function (direction) { return ({
        refHandlerName: direction + "Resize",
        top: /n/.test(direction),
        right: /e/.test(direction),
        bottom: /s/.test(direction),
        left: /w/.test(direction),
    }); });
};
var ROTATE_HANDLE_LOCATIONS = ['ne', 'se', 'sw', 'nw'];
/**
 * Generates configuration values useful for building rotate observables.
 * Configs are built for each corner (4 configs in total).
 */
exports.calculateRotateObservableConfigs = function () {
    return ROTATE_HANDLE_LOCATIONS.map(function (direction) { return ({
        refHandlerName: direction + "Rotate",
        top: /n/.test(direction),
        right: /e/.test(direction),
        bottom: /s/.test(direction),
        left: /w/.test(direction),
    }); });
};
/**
 * Round a number to a given interval. It is precise to, at most,
 * 2 decimal points to avoid floating point rounding errors.
 */
exports.round = function (value, interval) {
    if (interval === void 0) { interval = 0.1; }
    var result = Math.round(value / interval) * interval;
    return +result.toFixed(2);
};
/**
 * Check if a variable is a function.
 */
exports.isFunction = function (f) {
    return f && {}.toString.call(f) === '[object Function]';
};
/**
 * Generate a random alpha-numeric string.
 */
exports.randomString = function () {
    return Math.random()
        .toString(36)
        .slice(2);
};
//# sourceMappingURL=misc.js.map